/** password-field.tsx — Ô mật khẩu có nút hiện/ẩn + thanh độ mạnh. */
import { useState, type InputHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { Eye, EyeOff } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'
import { passwordStrength } from './auth-helpers'
import { AUTH_INPUT } from './auth-layout'

export function PasswordInput({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  const { t } = useTranslation('authPages')
  const [show, setShow] = useState(false)
  return (
    <div className="relative">
      <Input {...props} type={show ? 'text' : 'password'} className={cn(AUTH_INPUT, 'pr-11', className)} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? t('passwordField.hide') : t('passwordField.show')}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-muted-foreground hover:text-foreground"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  )
}

const BAR = ['bg-muted', 'bg-destructive', 'bg-warning', 'bg-primary', 'bg-success']

export function StrengthMeter({ password }: { password: string }) {
  const s = passwordStrength(password)
  return (
    <div className="space-y-1" aria-live="polite">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <span key={i} className={cn('h-1 flex-1 rounded-full', i <= s.level ? BAR[s.level] : 'bg-muted')} />
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        {s.label && <span className="font-medium text-foreground">{s.label}</span>}
        {s.label && s.hint ? ' · ' : ''}
        {s.hint}
      </p>
    </div>
  )
}
